(function () {
  const money = (cents) => {
    try {
      return 'Rs. ' + (Number(cents) / 100).toLocaleString('en-PK', { maximumFractionDigits: 0 });
    } catch (e) {
      return 'Rs. ' + Math.round(Number(cents) / 100);
    }
  };

  const waDigits = () => {
    const raw = (window.OT_CART_CONFIG && window.OT_CART_CONFIG.whatsapp) || '923228991816';
    return String(raw).replace(/\D/g, '');
  };

  const $ = (sel, root = document) => root.querySelector(sel);

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function updateCount(cart) {
    const el = document.getElementById('cart-count') || document.querySelector('.cart-count');
    if (!el) return;
    const n = cart.item_count || 0;
    el.textContent = String(n);
    el.style.display = n > 0 ? 'flex' : 'none';
  }

  function buildWhatsAppLink(cart) {
    const lines = (cart.items || []).map((item, i) => {
      return `${i + 1}. ${item.product_title} — ${item.variant_title || 'Default'} (x${item.quantity}) — ${money(item.final_line_price)}`;
    });
    const text =
      `Hi! 👋\n\nI'd like to order:\n` +
      lines.join('\n') +
      `\n\nTotal: ${money(cart.total_price)}\n\nPlease confirm my order and delivery details.`;
    return `https://wa.me/${waDigits()}?text=${encodeURIComponent(text)}`;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function lineImage(item) {
    const cfg = (window.OT_CART_CONFIG && window.OT_CART_CONFIG.images) || {};
    const variant = String(item.variant_title || '').toLowerCase();
    const handle = String(item.handle || item.product_handle || '').toLowerCase();
    const title = String(item.product_title || '').toLowerCase();

    if (handle.indexOf('couple') !== -1 || title.indexOf('couple') !== -1) {
      return cfg.couple || '';
    }
    if (variant.indexOf('women') !== -1 || variant.indexOf('balance') !== -1) {
      return cfg.women || '';
    }
    if (variant.indexOf('men') !== -1 || variant.indexOf('active') !== -1) {
      return cfg.men || '';
    }

    const raw =
      (item.featured_image && (item.featured_image.url || item.featured_image.src)) ||
      item.image ||
      '';
    if (!raw) return cfg.men || '';
    return String(raw).replace(/^\/\//, 'https://');
  }

  function renderCart(cart) {
    const body = $('#ot-cart-drawer-body');
    const footer = $('#ot-cart-drawer-footer');
    const totalEl = $('#ot-cart-total-price');
    const waBtn = $('#ot-cart-wa-btn');
    if (!body) return;
    updateCount(cart);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p></div>';
      if (totalEl) totalEl.innerHTML = money(0);
      if (waBtn) waBtn.removeAttribute('href');
      if (footer) {
        footer.hidden = true;
        footer.setAttribute('hidden', '');
        footer.style.display = 'none';
      }
      return;
    }

    body.innerHTML =
      '<div class="cart-items">' +
      cart.items
        .map((item) => {
          const imgUrl = lineImage(item);
          const img = imgUrl
            ? `<img src="${escapeHtml(imgUrl)}" alt="${escapeHtml(item.product_title)}" width="78" height="78" loading="lazy">`
            : '';
          const key = item.key;
          return `<div class="cart-item">
  <div class="cart-item__img">${img}</div>
  <div class="cart-item__info">
    <p class="cart-item__title">${escapeHtml(item.product_title)}</p>
    <p class="cart-item__variant">${escapeHtml(item.variant_title || '')}</p>
    <p class="cart-item__price">${money(item.final_line_price)}</p>
    <div class="ot-cart-item-actions">
      <div class="cart-item__qty-row ot-qty-pill" role="group" aria-label="Quantity">
        <button type="button" class="ot-qty-pill__btn" data-ot-qty="${escapeHtml(key)}" data-ot-next="${item.quantity - 1}" aria-label="${item.quantity <= 1 ? 'Remove item' : 'Decrease'}">−</button>
        <span class="ot-qty-pill__val" aria-live="polite">${item.quantity}</span>
        <button type="button" class="ot-qty-pill__btn" data-ot-qty="${escapeHtml(key)}" data-ot-next="${item.quantity + 1}" aria-label="Increase">+</button>
      </div>
      <button type="button" class="ot-remove-link" data-ot-qty="${escapeHtml(key)}" data-ot-next="0">Remove</button>
    </div>
  </div>
  <button type="button" class="cart-item__remove" data-ot-qty="${escapeHtml(key)}" data-ot-next="0" aria-label="Remove item">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
  </button>
</div>`;
        })
        .join('') +
      '</div>';

    body.querySelectorAll('[data-ot-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        OT.cartQty(btn.getAttribute('data-ot-qty'), btn.getAttribute('data-ot-next'));
      });
    });

    if (footer) {
      footer.hidden = false;
      footer.removeAttribute('hidden');
      footer.style.display = 'flex';
    }
    if (totalEl) totalEl.innerHTML = money(cart.total_price);
    if (waBtn) waBtn.href = buildWhatsAppLink(cart);

    const note = $('#ot-cart-shipping-note');
    if (note) {
      const free = cart.total_price >= 249900;
      note.textContent = free
        ? '✓ Free delivery · Open-parcel policy'
        : 'Fast shipping · Open-parcel policy';
    }
  }

  window.OT = window.OT || {};

  OT.openCart = async function () {
    const drawer = document.getElementById('ot-cart-drawer');
    const overlay = document.getElementById('ot-cart-overlay');
    try {
      const cart = await fetchCart();
      renderCart(cart);
    } catch (e) {
      const body = document.getElementById('ot-cart-drawer-body');
      if (body) body.innerHTML = '<div class="cart-empty"><p>Could not load cart. Please try again.</p></div>';
    }
    if (drawer) {
      drawer.classList.add('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    if (overlay) overlay.classList.add('cart-overlay--visible');
    document.documentElement.style.overflow = 'hidden';
  };

  OT.closeCart = function () {
    const drawer = document.getElementById('ot-cart-drawer');
    const overlay = document.getElementById('ot-cart-overlay');
    if (drawer) {
      drawer.classList.remove('cart-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('cart-overlay--visible');
    document.documentElement.style.overflow = '';
  };

  OT.cartQty = async function (keyOrId, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: keyOrId, quantity: Math.max(0, Number(qty) || 0) }),
    });
    const cart = await fetchCart();
    renderCart(cart);
  };

  OT.addToCart = async function (variantId, quantity, openDrawer) {
    const id = Number(variantId);
    const qty = Math.max(1, Number(quantity) || 1);
    if (!id) {
      alert('Please choose a plan first.');
      return false;
    }

    let res;
    try {
      res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id, quantity: qty }] }),
      });
    } catch (e) {
      alert('Network error adding to cart. Please try again.');
      return false;
    }

    // Password page / HTML error responses
    const ctype = (res.headers.get('content-type') || '').toLowerCase();
    if (res.status === 401 || res.status === 302 || res.url.indexOf('/password') !== -1) {
      alert('Store is password-protected. Unlock Online Store → Preferences, then try again.');
      return false;
    }

    if (!res.ok) {
      let msg = 'Could not add to cart.';
      if (ctype.indexOf('json') !== -1) {
        try {
          const err = await res.json();
          msg = err.description || err.message || msg;
        } catch (e) {}
      } else {
        msg = 'Could not add to cart (store may still be password locked).';
      }
      alert(msg);
      return false;
    }

    if (openDrawer !== false) await OT.openCart();
    else {
      try {
        const cart = await fetchCart();
        updateCount(cart);
      } catch (e) {}
    }
    return true;
  };

  async function handleProductSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    const id = form.querySelector('[name="id"]')?.value;
    const qty =
      document.getElementById('form-qty')?.value ||
      document.getElementById('qty-input')?.value ||
      1;
    const btn = document.getElementById('atc-btn') || form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.dataset.otLabel = btn.textContent;
      btn.textContent = 'Adding...';
    }
    try {
      await OT.addToCart(id, qty, true);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.otLabel || 'Add to Cart';
      }
    }
  }

  function bindForms() {
    const form = document.getElementById('ot-product-form');
    if (form && !form.dataset.otBound) {
      form.dataset.otBound = '1';
      form.addEventListener('submit', handleProductSubmit);
    }

    const atc = document.getElementById('atc-btn');
    if (atc && !atc.dataset.otBound) {
      atc.dataset.otBound = '1';
      atc.addEventListener('click', function (e) {
        // Backup if native submit is blocked/hijacked
        const formEl = document.getElementById('ot-product-form');
        if (!formEl) return;
        e.preventDefault();
        handleProductSubmit({ preventDefault() {}, stopPropagation() {}, currentTarget: formEl });
      });
    }

    const coupleForm = document.getElementById('ot-couple-form');
    if (coupleForm && !coupleForm.dataset.otBound) {
      coupleForm.dataset.otBound = '1';
      coupleForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const id =
          coupleForm.querySelector('input[name="id"]:checked')?.value ||
          coupleForm.querySelector('input[name="id"]')?.value;
        const btn = coupleForm.querySelector('.js-couple-atc');
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding...';
        }
        try {
          await OT.addToCart(id, 1, true);
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Add Couple Pack to Cart';
          }
        }
      });
    }

    document.querySelectorAll('.cart-toggle-btn, [data-ot-open-cart]').forEach((el) => {
      if (el.dataset.otBound) return;
      el.dataset.otBound = '1';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        OT.openCart();
      });
    });

    fetchCart().then(updateCount).catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindForms);
  } else {
    bindForms();
  }
})();
